import React, {Component} from 'react';
import {Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import ActionLink from "../../../../controls/ActionLink";
import Moment from "react-moment";
import PdfViewerModal from "../../../../modals/PdfViewerModal";
import AdvertContactsModal from "./AdvertContactsModal";
import {UserContext} from "../../../../auth/Auth";
import LoginModal from "../../../../modals/LoginModal";
import BackEnd from "../../../../backend/BackEnd";
import {successToast} from "../../../../utils/toasts";
import ConfirmationModal from "../../../../modals/ConfirmationModal";
import ImageViewerModal from "../../../../modals/ImageViewerModal";

class AdvertDetailsModal extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showRemoveMyAdConfirmModal: false,
        showContactsModal: false,
        showSpecificationModal: false,
        showImageViewerModal: false,
        specificationId: null,
        showLoginModal: false,
        imageIndex: 0
    };

    render() {
        const {data, onRemove, ...props} = this.props;
        const loginModalBeforeForm = (
            <p>
                Для просмотра и создания объявлений, пожалуйста, введите свой номер мобильного{' '}
                телефона. На указанный номер будет выслана смс с 4-значным кодом для его верификации.{' '}
                Данный номер будет использоваться в дальнейшем для вашей идентификации.
            </p>
        );
        const imageThumbUrl = data.thumbImages.length
            ?  new BackEnd.ViewImage.View().createUrl({
                imageId: data.thumbImages[this.state.imageIndex]
            })
            : (data.article && data.article !== 'U3' && data.article !== 'U4' ? '/assets/img/pallets/' + data.article + '.png' : null);
        const imageThumb = imageThumbUrl
            ? <img style={{width: '100%'}} src={imageThumbUrl}/>
            : '';
        
        const colCenter = (
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-6">
                        <i className="fa fa-certificate" /> {data.condition}
                    </div>
                    <div className="col-md-6">
                        <i className="fa fa-file" /> {data.gost}
                    </div>
                </div>
                <div className="row m-t-1">
                    <div className="col-md-6">
                        <i className="fa fa-expand" /> {data.size}
                    </div>
                    <div className="col-md-6">
                        <i className="fa fa-tint" /> {data.humidity}
                    </div>
                </div>
                <div className="row m-t-1">
                    <div className="col-md-6">
                        <i className="fa fa-star-o" /> {data.quality}
                    </div>
                    <div className="col-md-6">
                        <i className="fa fa-bars" /> {data.deckType}
                    </div>
                </div>
            </div>
        );
        
        const colCenterComment = data.comment ? (
            <div className="col-md-12">
                <div className="form-group" style={{ marginTop: "7px" }}>
                    <label htmlFor="comment">Комментарий</label>
                    <textarea className="form-control" rows="3" style={{ resize: "none" }}
                        disabled
                        value={data.comment}
                    />
                </div>
            </div>
        ) : null;

        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>№ {data.advertNumber} от <Moment format="DD.MM.YYYY">{data.createdAt}</Moment></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="panel" id="first-tender">
                        <div className="panel-heading">
                    <span className="panel-title">
                        <strong>{data.companyName}</strong> <span
                        className="label label-pill label-info">{data.advertType}</span>
                        {
                            data.isMy &&
                            <span className="label label-pill label-success">Моё</span>
                        }
                    </span>
                        </div>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <div>
                                        <ActionLink onClick={() => this.setState({showImageViewerModal: true})}>
                                            {imageThumb}
                                        </ActionLink>
                                    </div>
                                    <div className="m-t-1 text-center">
                                        <OverlayTrigger placement="bottom"
                                                        overlay={
                                                            <Tooltip id="prev-image-thumb">
                                                                Предыдущее изображение
                                                            </Tooltip>}>
                                            <ActionLink className="font-size-16 text-muted"
                                                        style={{visibility: this.state.imageIndex <= 0 ? 'hidden' : ''}}
                                                        onClick={() => this.prevImage()}>
                                                <i className="fa fa-arrow-left"/>
                                            </ActionLink>
                                        </OverlayTrigger>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <OverlayTrigger placement="bottom"
                                                        overlay={
                                                            <Tooltip id="next-image-thumb">
                                                                Следующее изображение
                                                            </Tooltip>}>
                                            <ActionLink className="font-size-16 text-muted"
                                                        style={{visibility: this.state.imageIndex >= data.thumbImages.length - 1 ? 'hidden' : ''}}
                                                        onClick={() => this.nextImage()}>
                                                <i className="fa fa-arrow-right"/>
                                            </ActionLink>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="row">
                                        {
                                            data.isUnsorted
                                                ? <p>Неотсортированные паллеты</p>
                                                : colCenter
                                        }
                                    </div>
                                    <div className="row">
                                        {colCenterComment}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div style={{textAlign: 'center', paddingTop: '8px'}}>
                                        <span style={{
                                            fontWeight: '700',
                                            fontSize: '37px'
                                        }}>{data.costPerItem}</span>&nbsp;
                                        <span style={{fontWeight: '700', fontSize: '37px'}}>р./шт.</span>&nbsp;
                                        <br/>
                                        <span style={{fontWeight: '700', fontSize: '20px'}}>{data.taxTypeName}</span>
                                    </div>
                                    <div style={{marginTop: '10px', marginBottom: '10px'}}>
                                        Частота поставки: {data.totalCount} шт.&nbsp;{data.repeatabilityTypeName}
                                    </div>
                                    <div>
                                        {data.deliveryTypeName}: {data.placeShortNameWhithRegion}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AdvertContactsModal data={data}
                                         show={this.state.showContactsModal}
                                         onHide={() => this.setState({showContactsModal: false})}/>
                    {
                        data.specDocumentId &&
                        <PdfViewerModal documentId={data.specDocumentId}
                                        allowAnonymous={true}
                                        show={this.state.showSpecificationModal}
                                        onHide={() => this.setState({showSpecificationModal: false})}/>
                    }
                    <LoginModal beforeForm={loginModalBeforeForm}
                                show={this.state.showLoginModal}
                                onLogin={() => window.location.reload()}
                                onHide={() => this.setState({showLoginModal: false})}/>
                    <ConfirmationModal show={this.state.showRemoveMyAdConfirmModal}
                                       onConfirm={() => this.confirmRemoveMyAd()}
                                       onHide={() => this.setState({showRemoveMyAdConfirmModal: false})}>
                        После снятия объявления не будет возможности его восстановить.
                        {' '}
                        Вы действительно хотите снять объявление?
                    </ConfirmationModal>
                    <ImageViewerModal documentId={data.originalImages[this.state.imageIndex]}
                                      allowDownload={false}
                                      show={this.state.showImageViewerModal}
                                      onHide={() => this.setState({showImageViewerModal: false})}/>
                </Modal.Body>
                <Modal.Footer>
                    {
                        data.specDocumentId &&
                        <div className="pull-left">
                            <i className="fa fa-file-pdf-o"/>&nbsp;
                            <ActionLink onClick={() => this.setState({showSpecificationModal: true})}>
                                Смотреть подробную спецификацию
                            </ActionLink>
                        </div>
                    }
                    {
                        data.isMy &&
                        <button type="button"
                                className="btn btn-danger"
                                onClick={() => this.openRemoveMyAdModal()}>
                            <i className="fa fa-ban"/> Снять объявление
                        </button>
                    }
                    <button role="button" className="btn btn-success"
                            onClick={() => this.openContactsModal()}>
                        <i className="fa fa-phone"/> Контакты
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    prevImage() {
        const {imageIndex} = this.state;

        if (imageIndex > 0)
            this.setState({imageIndex: imageIndex - 1});
    }

    nextImage() {
        const {data} = this.props;
        const {imageIndex} = this.state;

        if (imageIndex < data.thumbImages.length - 1)
            this.setState({imageIndex: imageIndex + 1});
    }

    openContactsModal() {
        const userContext = UserContext.get();
        if (userContext) {
            this.setState({showContactsModal: true});
        }
        else {
            this.setState({showLoginModal: true});
        }
    }

    openRemoveMyAdModal() {
        this.setState({
            showRemoveMyAdConfirmModal: true,
            showContactsModal: false
        });
    }

    async confirmRemoveMyAd() {
        let deleteAdvertEndpoint = new BackEnd.Adverts.DeleteAdvert();
        let result = await deleteAdvertEndpoint.call({
            id: this.props.data.advertId
        });

        if (result.success) {
            successToast(`Объявление успешно снято`);
            this.props.onRemove();
        }
    }
}

export default AdvertDetailsModal;


// WEBPACK FOOTER //
// ./src/pages/Adverts/AdvertList/modals/AdvertDetailsModal.js